import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import { IListWayFilterQueryParams, IWayFilterPatchBody, IWayFilterPostBody, IWayFilterResponse } from '../types'
import { Resources } from './ResourceTypes'

export class WayFilterResource extends GenericResource<
  IWayFilterResponse,
  IListWayFilterQueryParams,
  IWayFilterPatchBody,
  IWayFilterPostBody
> {
  public get = this.buildGet()
  public post = this.buildPost()
  public patch = this.buildPatch()
  public delete = this.buildDel()
  public list = this.buildList()

  constructor(
    agent: IHttpAgent,
    private readonly geographyId: string,
  ) {
    super(`geographies/${geographyId}/${Resources.WayFilters}`, agent)
  }
}
